// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__1CcKc","label":"Section_label__2Kw8V","contentWrap":"Section_contentWrap__hltI-","footer":"Section_footer__2AVLM","footerInner":"Section_footerInner__3r-_D"};